import { EnvInterface } from '@interfaces';

export const environment: EnvInterface = {
  production: true,
  apiUrl: 'https://dev-tya.wlcmapps.com/api/v2',
  whitelistedDomains: ['https://dev-tya.wlcmapps.com'],
  webAppUrl: 'https://connect.dev-tya.wlcmapps.com',
  mediaUrl: 'https://dev-tya.wlcmapps.com/s3-media',
};
